import React, { useEffect, useState } from "react";
import { FieldConfig, FieldSectionConfig } from "../../../../../models/Models";
import { Content, VideoAsset } from "../../../../../models/vod/Models";
import {
    useEditVideoAsset,
} from "../../../../../services/vod/Query";
import Modal from "../../../../../context/modal/Modal";
import EditForm from "./EditForm";
import dayjs from "dayjs";

interface Props {
    modalId: string;
    openModal: boolean;
    onClose: () => void;
    content: Content;
}

const VideoAssetFormModal = ({
    content,
    modalId,
    openModal,
    onClose,
}: Props) => {
    const [ videoAsset, setVideoAsset ] = useState<VideoAsset | undefined | null>(
        content?.videoAsset
    );
    const editVideoAsset = useEditVideoAsset();
    const formatVideoAssetDuration = (videoAsset?: VideoAsset | null) => {
        if (!videoAsset) return videoAsset;
        const runTime = videoAsset.runTime;

        return {
            ...videoAsset,
            runTime: !runTime || !runTime.includes("PT") ? runTime : dayjs
                .duration(runTime).format("HH:mm:ss"),
        };
    };

    useEffect(() => {
        if (content)
            setVideoAsset(
                formatVideoAssetDuration(content.videoAsset),
            );

    }, [  content ]);

    const videoAssetConfig: FieldConfig<VideoAsset>[] = [
        {
            path: "videoAsset",
            label: "Video Asset",
            type: "group",
            fields: [
                { path: "url", label: "Url", type: "text" },
                { path: "runTime", label: "Runtime", type: "duration" },
            ],
        },
    ];
    const fieldSectionConfigs: FieldSectionConfig<VideoAsset>[] = [ {
        fields: videoAssetConfig,
    } ];

    const submit = async (submittedVideoAsset: { videoAsset: VideoAsset }) => {
            const videoAsset = submittedVideoAsset.videoAsset;
            let runTime = videoAsset.runTime;

            if (runTime) {
                const splitDuration = runTime.split(":");

                if (splitDuration.length === 3) {
                    const [ hours, minutes, seconds ] = splitDuration.map(timeUnit => Number(timeUnit));
                    runTime = dayjs.duration({ hours, minutes, seconds }).toISOString();
                }
            }
            videoAsset.runTime = runTime;

            await editVideoAsset.mutateAsync({
                ...content,
                videoAsset,
            });
    };

    return (
        <Modal
            modalTitle={"Edit Video Assets"}
            modalId={modalId}
            modalSize={"w-[60vw] h-fit max-h-[80vh]"}
            openModal={openModal} onClose={onClose}
        >
            <EditForm
                modalId={modalId}
                config = {fieldSectionConfigs}
                initialValues = {{ videoAsset: videoAsset as VideoAsset }}
                onSubmit = {submit}
            />
        </Modal>
    );
};

export default VideoAssetFormModal;